// src/util/throwError.ts
var throwError = function throwError() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  throw new Error("\uD83D\uDEE1\uFE0FArmor error: ".concat(message));
};
export { throwError };